import Draw from 'draw-on-canvas'

const WIDTH = 360;
const HEIGHT = 150;

export default () => {

    const fields = document.querySelectorAll('.js-sign-pad');
    let counter = 0;
    const pads = {};


    function dot(context, x, y) {
        context.beginPath();
        context.fillStyle = "#000000";
        context.arc(x,y,1,0,Math.PI*2,true);
        context.fill();
        context.stroke();
        context.closePath();
    }

    function line(context, fromX,fromY, toX,toY) {
        context.beginPath();
        context.moveTo(fromX, fromY);
        context.lineTo(toX, toY);
        context.stroke();
        context.closePath();
    }

    function initSignPadField(field) {
        counter += 1;

        let lastX;
        let lastY;

        const html = '<div class=" sign-pad__board-holder">' +
            '<div class="sign-pad__board">' +
                '<div class="js-draw-area sign-pad__canvas"></div>' +
                '<div class="sign-pad__clear"><span class="js-clear btn btn--sm">Clear</span></div>' +
            '</div>' +
        '</div>';
        field.innerHTML += html;

        const pad = field.querySelector('.js-draw-area');
        const clearButton = field.querySelector('.js-clear');
        const settings = {
            backgroundColor: 'white',
            strokeColor: 'black',
            strokeWeight: 1
        };

        const canvas = document.createElement('canvas');
        canvas.width = WIDTH;
        canvas.height = HEIGHT;
        pad.append(canvas);

        let canvasStop = canvas.offsetTop;
        let mouseDown = false;

        const context = canvas.getContext("2d");
        context.strokeStyle = "#000000";
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.lineWidth = 1;
        context.fillStyle = "#ffffff";
        context.rect(0, 0, WIDTH, HEIGHT);
        context.fill();

        canvas.addEventListener('mousedown', (e) => {
            e.preventDefault();
            lastX = e.layerX;
            lastY = e.layerY;
            dot(context, lastX,lastY);
            mouseDown = true;
        });

        canvas.addEventListener('mousemove', (e) => {
            e.preventDefault();
            if (mouseDown) {
                const newX = e.layerX;
                const newY = e.layerY;
                line(context, lastX, lastY, newX, newY);
                lastX = newX;
                lastY = newY;
            }
        });

        canvas.addEventListener('mouseup', (e) => {
            mouseDown = false;
        });

        canvas.addEventListener('touchstart', (e) => {
            e.preventDefault();
            const cX = canvas.getBoundingClientRect().x;
            const cY = canvas.getBoundingClientRect().y;
            lastX = e.touches[0].clientX - cX;
            lastY = e.touches[0].clientY - cY;
            dot(context, lastX,lastY);
        });

        canvas.addEventListener('touchmove', (e) => {
            e.preventDefault();
            const cX = canvas.getBoundingClientRect().x;
            const cY = canvas.getBoundingClientRect().y;
            const newX = e.touches[0].clientX - cX;
            const newY = e.touches[0].clientY - cY;

            line(context, lastX,lastY, newX,newY);

            lastX = newX;
            lastY = newY;
        });


        clearButton.addEventListener('click', () => {
            context.fillStyle = "#ffffff";
            context.rect(0, 0, WIDTH, HEIGHT);
            context.fill();
        });
    }

    function populateForm() {
        const fieldsWithinForm = document.querySelectorAll('.js-sign-pad');
        if (fieldsWithinForm.length) {
            for (const fieldWithinForm of fieldsWithinForm) {
                const canvas = fieldWithinForm.querySelector('canvas');
                const dataURL = canvas.toDataURL('image/png');
                // const draw = pads[fieldWithinForm.getAttribute('data-draw')];
                // const dataURL = draw.canvas.toDataURL('image/png');
                fieldWithinForm.querySelector('input[type="hidden"]').value = dataURL;
            }
        }
    }

    if (fields.length) {
        for (const field of fields) {
            initSignPadField(field);
        }

        const forms = document.querySelectorAll('form');
        for (const form of forms) {
            form.addEventListener('submit', function (e) {
                populateForm();
                return true;
            });
        }

    }



}
